module.exports = __webpack_public_path__ + "static/goodenergyquiz-af52271400b24ec6e0aff55fd402ecce.png";